import React from 'react'

// Components
import JoinOptions from '../../../../components/user/JoinOptions'

const JoinCounselor = () => {
   return (
      <JoinOptions isCounselor={true} />
   )
}

export default JoinCounselor